import { defineMessages } from 'react-intl';

export const IDVErrors = defineMessages({
  session_cancelled: {
    id: 'identity_verification.session_cancelled',
    defaultMessage:
      'This reservation requires identity verification to be completed. Please try again in order to book the space.'
  },
  consent_declined: {
    id: 'identity_verification.consent_declined',
    defaultMessage:
      'This reservation requires identity verification to be completed. Please try again in order to book the space.'
  },
  under_supported_age: {
    id: 'identity_verification.under_supported_age',
    defaultMessage: 'You do not meet the age requirement to book this space.'
  },
  retry_not_allowed: {
    id: 'identity_verification.retry_not_allowed',
    defaultMessage:
      'Your previous verification attempt failed, please contact our support team {link} for assistance.'
  },
  generic_error: {
    id: 'identity_verification.generic_error',
    defaultMessage:
      'We were unable to verify your identity. Please try again ensuring you are taking a live image of your document and selfie in a well-lit area, free from glare, and on a dark background.'
  }
});
